import * as ReactCheckbox from "@radix-ui/react-checkbox";
import { CheckIcon, Minus } from "lucide-react";
import React from "react";

import { type PropsWithClassName, cn } from "@/components/podkit/lib/cn";

type CheckboxProps = React.ComponentPropsWithoutRef<typeof ReactCheckbox.Root> & PropsWithClassName;

export type CheckedState = ReactCheckbox.CheckedState;

export const Checkbox = React.forwardRef<React.ElementRef<typeof ReactCheckbox.Root>, CheckboxProps>(
    ({ className, ...props }, ref) => {
        return (
            <ReactCheckbox.Root
                className={cn(
                    "size-4",
                    "border-1 rounded",
                    "flex items-center justify-center",
                    "transition-opacity duration-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-surface-primary focus-visible:ring-offset-0",
                    // checked state colors
                    "data-[state=checked]:bg-content-brand data-[state=checked]:hover:opacity-80 data-[state=checked]:disabled:opacity-40",
                    // indeterminate state colors
                    "data-[state=indeterminate]:bg-surface-brand data-[state=indeterminate]:hover:opacity-80 data-[state=indeterminate]:disabled:opacity-40",
                    "ona-theme:data-[state=indeterminate]:bg-content-brand",
                    // unchecked state colors
                    "data-[state=unchecked]:border data-[state=unchecked]:border-border-base data-[state=unchecked]:bg-transparent data-[state=unchecked]:hover:bg-surface-secondary data-[state=unchecked]:disabled:bg-surface-secondary",
                    className,
                )}
                {...props}
                ref={ref}
            >
                <span className="flex size-3 items-center justify-center">
                    <ReactCheckbox.Indicator>
                        {props.checked === "indeterminate" && <Minus className="pt-0.25 size-3 text-surface-primary" />}
                        {props.checked === true && <CheckIcon className="pt-0.25 size-3 text-surface-primary" />}
                    </ReactCheckbox.Indicator>
                </span>
            </ReactCheckbox.Root>
        );
    },
);
Checkbox.displayName = ReactCheckbox.Root.displayName;
